import { IMAGES_PATH } from ".";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import {
  ENUM_CURRENCY,
  ENUM_INTRESTED_IN_PRIORITY_LIST,
  ENUM_INVITATION_STATUS_HISTORY,
  ENUM_LOOKING_FOR,
  ENUM_MEETING_STATUS,
  ENUM_PAYMENT_STATUS,
  ENUM_PRICING_STRUCTURE,
  ENUM_PROJECT_ARCHIVE_REASON,
  ENUM_PROJECT_STATUS,
  ENUM_PROJECT_STATUS_CATEGORY,
  ENUM_RESCHEDULE_REASON_TYPE,
} from "../enums";

export const MEETING_RESCHEDULE_REASONS = [
  {
    label: "Scheduling conflict",
    value: ENUM_RESCHEDULE_REASON_TYPE.SCHEDULING_CONFLICT,
  },
  {
    label: "Emergency",
    value: ENUM_RESCHEDULE_REASON_TYPE.EMERGENCY,
  },
  {
    label: "Availability changed",
    value: ENUM_RESCHEDULE_REASON_TYPE.AVAILABILITY_CHANGED,
  },
  {
    label: "Technical issue",
    value: ENUM_RESCHEDULE_REASON_TYPE.TECHNICAL_ISSUE,
  },
  {
    label: "Other",
    value: ENUM_RESCHEDULE_REASON_TYPE.OTHER,
  },
] as const;

export const CONST_PROJECT_STATUS_TIMELINE_GROUPS = [
  {
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    label: "Review Responses",
  },
  {
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    label: "Scheduling",
  },
  {
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    label: "Scheduled",
  },
  {
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    label: "Completed",
  },
];

export const CONST_PROJECT_TIMELINE_COLORS = {
  completed: {
    bg: "#059669",
    label: "#047857",
    connector: "#059669",
  },
  active: {
    bg: "#2563EB",
    label: "#1F2937",
  },
  pending: {
    label: "#9CA3AF",
    border: "#D1D5DB",
    icon: "#9CA3AF",
  },
  error: {
    bg: "#DC2626",
    label: "#DC2626",
  },
};

export const CONST_PROJECT_TIMELINE_CATEGORY_ICONS = {
  [ENUM_PROJECT_STATUS_CATEGORY.NEW]: QuizOutlinedIcon,
  [ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING]: CalendarMonthOutlinedIcon,
  [ENUM_PROJECT_STATUS_CATEGORY.UPCOMING]: EventAvailableOutlinedIcon,
  [ENUM_PROJECT_STATUS_CATEGORY.PAST]: TaskAltOutlinedIcon,
};

export const CONST_CURRENCY_LIST = {
  [ENUM_CURRENCY.USD]: { intl: "en-US" },
};

export const CONST_MEETING_STATUS_LIST = {
  [ENUM_MEETING_STATUS.DONE]: {
    label: "Done",
    bgColor: "#e8f9f3",
    fontColor: "#41C197",
    eventBgColor: "#31C197",
  },
  [ENUM_MEETING_STATUS.REJECTED]: {
    label: "Rejected",
    bgColor: "#feeaf1",
    fontColor: "#F65C8D",
    eventBgColor: "#F4516C",
  },
  [ENUM_MEETING_STATUS.PENDING]: {
    label: "Pending",
    bgColor: "#ebefff",
    fontColor: "#5D78FF",
    eventBgColor: "#5867DD",
  },
};

export const CONST_INVITATION_STATUS_LIST = {
  [ENUM_INVITATION_STATUS_HISTORY.CREATED]: {
    label: "Invitation Sent",
    bgColor: "#e8f9f3",
    fontColor: "#41C197",
    eventBgColor: "#31C197",
  },
  [ENUM_INVITATION_STATUS_HISTORY.AWAITING_FOR_TIME_SLOT]: {
    label: "Awaiting for times",
    bgColor: "#ebefff",
    fontColor: "#5D78FF",
    eventBgColor: "#5867DD",
  },
  [ENUM_INVITATION_STATUS_HISTORY.AWAITING_FOR_TIME_SLOT_SELECTION]: {
    label: "Awaiting for times selection",
    bgColor: "#ebefff",
    fontColor: "#5D78FF",
    eventBgColor: "#5867DD",
  },
  [ENUM_INVITATION_STATUS_HISTORY.SEND_MEETING_LINK]: {
    label: "Zoom meeting link sent",
    bgColor: "#ebefff",
    fontColor: "#5D78FF",
    eventBgColor: "#5867DD",
  },
  [ENUM_INVITATION_STATUS_HISTORY.DONE]: {
    label: "Completed",
    bgColor: "#ebefff",
    fontColor: "#5D78FF",
    eventBgColor: "#5867DD",
  },
  [ENUM_INVITATION_STATUS_HISTORY.REJECTED]: {
    label: "Rejected",
    bgColor: "#feeaf1",
    fontColor: "#F65C8D",
    eventBgColor: "#F4516C",
  },
};

export const CONST_PAYMENT_STATUS_LIST = {
  [ENUM_PAYMENT_STATUS.SUCCESS]: {
    label: "Success",
    bgColor: "#e8f9f3",
    fontColor: "#41C197",
  },
  [ENUM_PAYMENT_STATUS.FAILED]: {
    label: "Failed",
    bgColor: "#feeaf1",
    fontColor: "#F65C8D",
  },
};

export const CONST_PROJECT_STATUS_LIST = {
  [ENUM_PROJECT_STATUS.CREATED]: {
    label: "Created",
    bgColor: "#78909C",
    fontColor: "#78909C",
    tagBgColor: "#EFF2F3",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
    auditLogLabel: "Created",
  },
  [ENUM_PROJECT_STATUS.REQUESTED]: {
    label: "Questions sent",
    bgColor: "#9848D8",
    fontColor: "#9848D8",
    tagBgColor: "#F3E9FA",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
    auditLogLabel: "Questions sent",
  },
  [ENUM_PROJECT_STATUS.DONE]: {
    label: "Meeting done",
    bgColor: "#187848",
    fontColor: "#187848",
    tagBgColor: "#E3EFE9",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    step: 6,
    displayLabel: "Done",
    auditLogLabel: "Meeting done",
  },
  [ENUM_PROJECT_STATUS.REJECTED]: {
    label: "Meeting rejected",
    bgColor: "#DC2626",
    fontColor: "#DC2626",
    tagBgColor: "#FBE5E5",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    auditLogLabel: "Meeting rejected",
  },
  [ENUM_PROJECT_STATUS.REJECTED_BY_CLIENT]: {
    label: "Meeting rejected by client",
    bgColor: "#DC2626",
    fontColor: "#DC2626",
    tagBgColor: "#FBE5E5",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    auditLogLabel: "Meeting rejected by client",
  },
  [ENUM_PROJECT_STATUS.REJECTED_BY_AMBASSADOR]: {
    label: "Meeting rejected by ambassador",
    bgColor: "#FAAB3D",
    fontColor: "#FAAB3D",
    tagBgColor: "#FFEDD3",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    auditLogLabel: "Meeting rejected by ambassador",
  },
  [ENUM_PROJECT_STATUS.CANCELED_BY_CLIENT]: {
    label: "Cancelled by client",
    bgColor: "#DC2626",
    fontColor: "#DC2626",
    tagBgColor: "#FBE5E5",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    auditLogLabel: "Cancelled by client",
  },
  [ENUM_PROJECT_STATUS.CANCELED_BY_AMBASSADOR]: {
    label: "Cancelled by ambassador",
    bgColor: "#DC2626",
    fontColor: "#DC2626",
    tagBgColor: "#FBE5E5",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    auditLogLabel: "Cancelled by ambassador",
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_RESPONSE]: {
    label: "Awaiting for response",
    bgColor: "#788492",
    fontColor: "#788492",
    tagBgColor: "#F3F5F6",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
    auditLogLabel: "Awaiting for response",
  },
  [ENUM_PROJECT_STATUS.RESPONDED]: {
    label: "Questions answered",
    bgColor: "#908CAB",
    fontColor: "#908CAB",
    tagBgColor: "#F0F1F4",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 2,
    auditLogLabel: "Questions answered",
  },
  [ENUM_PROJECT_STATUS.ADDED_TIME_SLOTS_BY_CLIENT]: {
    label: "Vendor Proposed Times",
    bgColor: "#4990B6",
    fontColor: "#4990B6",
    tagBgColor: "#CEF4FF",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 3,
    auditLogLabel: "Vendor Proposed Times",
  },
  [ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT]: {
    label: "Approved",
    bgColor: "#36C875",
    fontColor: "#36C875",
    tagBgColor: "#E6F8EE",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 3,
    auditLogLabel: "Approved by client",
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_TIME_SLOT]: {
    label: "Awaiting for times",
    bgColor: "#A58520",
    fontColor: "#A58520",
    tagBgColor: "#F9F4E5",
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 3,
    auditLogLabel: "Awaiting for times",
  },
  [ENUM_PROJECT_STATUS.SELECTED_TIME_SLOT_BY_AMBASSADOR]: {
    label: "Times Selected by ambassador",
    bgColor: "#0E7490",
    fontColor: "#0E7490",
    tagBgColor: "#E2EEF2",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Times Selected by ambassador",
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_TIME_SLOT_SELECTION]: {
    label: "Awaiting for times selection",
    bgColor: "#01B6E5",
    fontColor: "#01B6E5",
    tagBgColor: "#EDFBFF",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Awaiting for times selection",
  },
  [ENUM_PROJECT_STATUS.SEND_MEETING_LINK]: {
    label: "Scheduled",
    bgColor: "#216EDF",
    fontColor: "#216EDF",
    tagBgColor: "#E4EDFB",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    displayLabel: "Scheduled",
    auditLogLabel: "Scheduled",
  },
  [ENUM_PROJECT_STATUS.UPDATE_INVITATION]: {
    label: "Meeting rescheduled",
    bgColor: "#7C3AED",
    fontColor: "#7C3AED",
    tagBgColor: "#EFE7FD",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Meeting rescheduled",
  },
  [ENUM_PROJECT_STATUS.DONE_BY_CLIENT]: {
    label: "Mark as done by client",
    bgColor: "green",
    fontColor: "#41C197",
    tagBgColor: "#E8F9F3",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 6,
    displayLabel: "Mark as done by client",
    auditLogLabel: "Mark as done by client",
  },
  [ENUM_PROJECT_STATUS.DONE_BY_AMBASSADOR]: {
    label: "Mark as done by ambassador",
    bgColor: "green",
    fontColor: "#41C197",
    tagBgColor: "#E8F9F3",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 6,
    displayLabel: "Mark as done by ambassador",
    auditLogLabel: "Mark as done by ambassador",
  },
  [ENUM_PROJECT_STATUS.UPDATE_ATTENDEES_LIST_BY_AMBASSADOR]: {
    label: "Members added by ambassador",
    bgColor: "#D6507E",
    fontColor: "#D6507E",
    tagBgColor: "#FAE4EC",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    auditLogLabel: "Members added by ambassador",
  },
  [ENUM_PROJECT_STATUS.SUGGESTED_TIME_SLOT_BY_AMBASSADOR]: {
    label: "Times Suggested by ambassador",
    bgColor: "#658C9B",
    fontColor: "#658C9B",
    tagBgColor: "#D8F9FF",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Times Suggested by ambassador",
  },
  [ENUM_PROJECT_STATUS.UPDATE_ATTENDEES_LIST_BY_CLIENT]: {
    label: "Members added",
    bgColor: "#D6507E",
    fontColor: "#D6507E",
    tagBgColor: "#FAE4EC",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    auditLogLabel: "Members added",
  },
  [ENUM_PROJECT_STATUS.UPDATE_ATTENDEES_LIST_BY_ADMIN]: {
    label: "Members updated by admin",
    bgColor: "#D6507E",
    fontColor: "#D6507E",
    tagBgColor: "#FAE4EC",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    auditLogLabel: "Members updated by admin",
  },
  [ENUM_PROJECT_STATUS.ARCHIVE]: {
    label: "Archived",
    bgColor: "#F96D3C",
    fontColor: "#F96D3C",
    tagBgColor: "#F4E9E9",
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
    displayLabel: "Archived",
    auditLogLabel: "Archived",
  },
  [ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_CLIENT]: {
    label: "Requested coordination by client",
    bgColor: "#CD9282",
    fontColor: "#CD9282",
    tagBgColor: "#F4EDEB",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Marked as unavailable by client",
  },
  [ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_AMBASSADOR]: {
    label: "Requested coordination by ambassador",
    bgColor: "#CD9282",
    fontColor: "#CD9282",
    tagBgColor: "#F4EDEB",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Marked as unavailable by ambassador",
  },
  [ENUM_PROJECT_STATUS.RE_SCHEDULE]: {
    label: "Meeting rescheduled (re-schedule)",
    bgColor: "#7C3AED",
    fontColor: "#7C3AED",
    tagBgColor: "#EFE7FD",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Meeting rescheduled",
  },
  [ENUM_PROJECT_STATUS.RESCHEDULE_INITIATED]: {
    label: "Reschedule initiated",
    bgColor: "#7C3AED",
    fontColor: "#7C3AED",
    tagBgColor: "#EFE7FD",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Reschedule initiated",
  },
  [ENUM_PROJECT_STATUS.SCHEDULING_DELEGATED]: {
    label: "Scheduling delegated",
    bgColor: "#805040",
    fontColor: "#805040",
    tagBgColor: "#F0EAE8",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    auditLogLabel: "Scheduling delegated",
  },
  [ENUM_PROJECT_STATUS.DELEGATE_REMOVED]: {
    label: "Delegate removed",
    bgColor: "#57534E",
    fontColor: "#57534E",
    tagBgColor: "#F5F5F4",
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
    displayLabel: "Delegate removed",
    auditLogLabel: "Delegate removed",
  },
  [ENUM_PROJECT_STATUS.CONFIRMED_ATTENDANCE_BY_AMBASSADOR]: {
    label: "Attendance Confirmed",
    bgColor: "#009A00",
    fontColor: "#009A00",
    tagBgColor: "#CCE8B5",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    auditLogLabel: "Attendance Confirmed",
  },
  [ENUM_PROJECT_STATUS.MEETING_REMINDER_SENT]: {
    label: "Meeting reminder sent",
    bgColor: "#F47418",
    fontColor: "#F47418",
    tagBgColor: "#F8DEB0",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    displayLabel: "Meeting reminder sent",
    auditLogLabel: "Meeting reminder sent",
  },
  [ENUM_PROJECT_STATUS.AMBASSADOR_RESCHEDULE_REQUESTED]: {
    label: "Reschedule requested",
    bgColor: "#7C3AED",
    fontColor: "#7C3AED",
    tagBgColor: "#EFE7FD",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    displayLabel: "Reschedule requested",
    auditLogLabel: "Reschedule requested",
  },
  [ENUM_PROJECT_STATUS.VENDOR_RESCHEDULE_REQUESTED]: {
    label: "Reschedule requested by vendor",
    bgColor: "#5B21B6",
    fontColor: "#5B21B6",
    tagBgColor: "#F3E8FF",
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
    displayLabel: "Reschedule requested by vendor",
    auditLogLabel: "Reschedule requested by vendor",
  },
};

export const CONST_REJECT_OR_CANCEL_STATUSES = new Set([
  ENUM_PROJECT_STATUS.REJECTED,
  ENUM_PROJECT_STATUS.REJECTED_BY_CLIENT,
  ENUM_PROJECT_STATUS.REJECTED_BY_AMBASSADOR,
  ENUM_PROJECT_STATUS.CANCELED_BY_CLIENT,
  ENUM_PROJECT_STATUS.CANCELED_BY_AMBASSADOR,
]);

export const CONST_PROJECT_ARCHIVE_REASON = {
  [ENUM_PROJECT_ARCHIVE_REASON.CANCELLED]: "Cancelled",
  [ENUM_PROJECT_ARCHIVE_REASON.RE_SCHEDULE]: "Re-schedule",
};

export const CONST_LOOKING_FOR_LIST = [
  {
    label: "1:1 Introductory Sales Meetings",
    value: ENUM_LOOKING_FOR.ONE2ONE_INTRODUCTORY_SALES_MEETINGS,
  },
  { label: "1:1 Advisory Meetings", value: ENUM_LOOKING_FOR.ONE2ONE_ADVISORY },
  {
    label: "Advisory Board Members",
    value: ENUM_LOOKING_FOR.ADVISORY_BOARD_MEMBERS,
  },
  { label: "Investors", value: ENUM_LOOKING_FOR.INVESTORS },
];

export const CONST_INTRESTED_IN_PRIORITY_LIST = [
  {
    label: "Low",
    value: ENUM_INTRESTED_IN_PRIORITY_LIST.LOW,
  },
  { label: "Medium", value: ENUM_INTRESTED_IN_PRIORITY_LIST.MEDIUM },
  {
    label: "High",
    value: ENUM_INTRESTED_IN_PRIORITY_LIST.HIGH,
  },
];

export const FILE_TYPE_ICONS = {
  pdf: `${IMAGES_PATH}/pdf_icon.svg`,
  doc: `${IMAGES_PATH}/doc_icon.svg`,
  docx: `${IMAGES_PATH}/doc_icon.svg`,
  demo: `${IMAGES_PATH}/play_icon.svg`, // Assuming demoLink is a video file
  default: `${IMAGES_PATH}/document.svg`, // A default icon for unknown types
};

export const FILTER_OPERATORS = {
  EQ: "eq",
  NE: "ne",
  GT: "gt",
  GTE: "gte",
  LT: "lt",
  LTE: "lte",
  CONTAINS: "contains",
  IN: "in",
  NIN: "nin",
  ALL: "all",
};

export const FILTER_OPERATORS_LIST = [
  {
    label: "Equal",
    value: FILTER_OPERATORS.EQ,
    displayLabel: "equal to",
    tags: [
      "exact",
      "is",
      "equals",
      "equal",
      "is equal to",
      "equals to",
      "equal to",
    ],
  },
  {
    label: "Not Equal",
    value: FILTER_OPERATORS.NE,
    displayLabel: "not equal to",
    tags: ["not equal", "not equals", "not equal to"],
  },
  {
    label: "Greater Than",
    value: FILTER_OPERATORS.GT,
    displayLabel: "greater than",
    tags: ["greater than", "after", "more than"],
  },
  {
    label: "Greater Than or Equal",
    value: FILTER_OPERATORS.GTE,
    displayLabel: "greater than or equal to",
    tags: ["greater than or equal", "greater than equal"],
  },
  {
    label: "Less Than",
    value: FILTER_OPERATORS.LT,
    displayLabel: "less than",
    tags: ["less than", "before"],
  },
  {
    label: "Less Than or Equal",
    value: FILTER_OPERATORS.LTE,
    displayLabel: "less than or equal to",
    tags: ["less than or equal", "less than equal"],
  },
  {
    label: "Contains",
    value: FILTER_OPERATORS.CONTAINS,
    displayLabel: "contains",
    tags: ["contains", "contain"],
  },
  {
    label: "In",
    value: FILTER_OPERATORS.IN,
    displayLabel: "in",
    tags: ["in"],
  },
  {
    label: "Not In",
    value: FILTER_OPERATORS.NIN,
    displayLabel: "not in",
    tags: ["not in"],
  },
  {
    label: "All",
    value: FILTER_OPERATORS.ALL,
    displayLabel: "all",
    tags: ["all"],
  },
];

export const CONST_MP_PRICING = [
  { id: "Thousands", label: "$ - Thousands" },
  { id: "Ten Thousands", label: "$$ - Ten Thousands" },
  { id: "Hundred Thousands", label: "$$$ - Hundred Thousands" },
  { id: "Millions", label: "$$$$ - Millions" },
];

export const CONST_MP_PRICING_STRUCTURE = [
  ENUM_PRICING_STRUCTURE.PER_SEAT,
  ENUM_PRICING_STRUCTURE.PER_DATA,
];

export const CONST_MP_CERTIFICATION_LIST = ["ISO", "FedRamp", "SOC2"];

